















import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import flagKeys from '@/constants/flagKeys';
import { IBusinessType } from '@/models/business';
import {
  appIsActive,
  widgetIsActive,
  widgetIsEnabled
} from '@/router/validators/utils';
import eventBus from '@/utils/eventBus';
import { Component, Prop, Vue } from 'vue-property-decorator';
import FilledButton from '../FilledButton/FilledButton.vue';

@Component({
  components: {
    FilledButton
  }
})
export default class BannerActivateWidget extends Vue {
  @Prop({ default: false }) hasToBeOnlineOnly?: boolean;

  onOpenActivateWidget() {
    if (widgetIsActive()) {
      eventBus.$emit(
        'openSubModal',
        new ModalOptionsV2({
          componentToRender: `activateFeatureWidgetModal`,
          hideCancelButton: false,
          icon: '',
          mobilePositionBottom: true,
          mobileFullScreen: false
        })
      );
    } else {
      this.$router.push('/settings/apps');
    }
  }

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get isOnlineOnly() {
    return this.business.type === IBusinessType.ONLINE;
  }

  get getFlags() {
    return this.$store.getters['flags/getFlags'] || [];
  }
}
